import { AuthGuard } from './guard/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SessionLoginComponent } from './pages/session-login/session-login.component';
import { TrocarSenhaComponent } from './pages/trocar-senha/trocar-senha.component';


export const routes: Routes = [
  { path: 'safe-gis', canActivate: [AuthGuard], loadChildren: () => import('../app/pages/safe-gis/safe-gis.module').then(e => e.SafeGisModule) },
  { path: 'login/:id', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'session-login', component: SessionLoginComponent },
  { path: 'trocar-senha', component: TrocarSenhaComponent },
  { path: '**', redirectTo: 'safe-gis' }

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
